module.exports = __webpack_public_path__ + "img/friend-1.0bd4d860.png";